let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7aPU6")).then(() => parcelRequire('d4USv'));